module.exports = __webpack_public_path__ + "static/media/2_en.a27d13d9.png";